import useDynamicPricesSettings from 'src/Libs/dynamic-power-prices/hooks/use-dynamic-prices-settings'
import { getIsDppAvailableForInstallationLocation } from 'src/Libs/dynamic-power-prices/utils/price-settings'
import { useTypedSelector } from 'src/State/RootReducer'
import { useCheckInstallationLocation } from '..'
import { useFarmContext } from 'src/Elements/Farm'

/**
 * This hook returns that the variable dynamic power price alert banner should be visible
 * if the dynamic power prices are enabled and the location is not suppotred yet.
 */
export const useDynamicPowerPriceAlertBannerConditions = (): boolean => {
  const storageId = useTypedSelector(state => state.storage.activeStorage)
  const { isFarm, farmMaster } = useFarmContext()
  const dynamicPowerPriceStorageIdToUse = isFarm ? farmMaster?.storageId : storageId
  const { countryCode } = useCheckInstallationLocation()
  const { dynamicPricesSettings } = useDynamicPricesSettings({ storageId: dynamicPowerPriceStorageIdToUse })
  const isAllowedLocation = getIsDppAvailableForInstallationLocation(countryCode)

  if (!dynamicPricesSettings || isAllowedLocation) return false

  return Boolean(dynamicPricesSettings.dynamicPricesForWallboxesEnabled || dynamicPricesSettings.dynamicPricesForBatteryEnabled)
}
